






































































import Vue from "vue";
import Component from "vue-class-component";
@Component({
  name: "Layout"

  // Toutes les options de composant sont autorisées ici.
})
export default class Layout extends Vue {
  image = require("@/assets/logo.png");
  icons = [
    {
      icon: "mdi-instagram",
      link: "https://www.instagram.com/identidys_echelle_reperage_dys/?hl=fr-ca"
    },
    {
      icon: "mdi-youtube",
      link: "https://www.youtube.com/channel/UCvFJprs2zEJPLu2vNuUkFcw"
    },
    {
      icon: "mdi-web",
      link: "https://www.identidys.com/"
    }
  ];

  mounted() {
    const item = localStorage.getItem("data");
    if (!item) {
      localStorage.setItem("data", JSON.stringify([]));
    }
  }
}
